/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenerateInvoiceRequestCompany } from './GenerateInvoiceRequestCompany';
import {
    GenerateInvoiceRequestCompanyFromJSON,
    GenerateInvoiceRequestCompanyFromJSONTyped,
    GenerateInvoiceRequestCompanyToJSON,
    GenerateInvoiceRequestCompanyToJSONTyped,
} from './GenerateInvoiceRequestCompany';

/**
 * 
 * @export
 * @interface GenerateInvoiceRequest
 */
export interface GenerateInvoiceRequest {
    /**
     * 
     * @type {GenerateInvoiceRequestCompany}
     * @memberof GenerateInvoiceRequest
     */
    company: GenerateInvoiceRequestCompany;
}

/**
 * Check if a given object implements the GenerateInvoiceRequest interface.
 */
export function instanceOfGenerateInvoiceRequest(value: object): value is GenerateInvoiceRequest {
    if (!('company' in value) || value['company'] === undefined) return false;
    return true;
}

export function GenerateInvoiceRequestFromJSON(json: any): GenerateInvoiceRequest {
    return GenerateInvoiceRequestFromJSONTyped(json, false);
}

export function GenerateInvoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInvoiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'company': GenerateInvoiceRequestCompanyFromJSON(json['company']),
    };
}

export function GenerateInvoiceRequestToJSON(json: any): GenerateInvoiceRequest {
    return GenerateInvoiceRequestToJSONTyped(json, false);
}

export function GenerateInvoiceRequestToJSONTyped(value?: GenerateInvoiceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company': GenerateInvoiceRequestCompanyToJSON(value['company']),
    };
}

